// Auto-dismiss flash notifications after 5 seconds
export default {
  mounted() {
    this.restartDismiss()
  },
  updated() {
    this.restartDismiss()
  },
  restartDismiss() {
    clearTimeout(this.timer)
    clearTimeout(this.fadeTimer)
    this.el.style.removeProperty("transition")
    this.el.style.removeProperty("opacity")
    this.el.style.removeProperty("display")
    this.timer = setTimeout(() => {
      this.el.style.transition = "opacity 300ms ease-in"
      this.el.style.opacity = "0"
      this.fadeTimer = setTimeout(() => {
        const key = this.el.dataset.flashKey
        this.pushEvent("lv:clear-flash", key ? { key } : {})
      }, 300)
    }, 5000)
  },
  destroyed() {
    clearTimeout(this.timer)
    clearTimeout(this.fadeTimer)
  }
}
